﻿// Arrow functions instead of function names
// to optimize minification
import "../webcomponents/_SessionTimer"
import { initalizeDiagrams } from "./_diagrammHandler"

/**
 * ------------------------------
 * Dom Watching utilities (to react to new inserted charts)
 * ------------------------------
 */
const onDomChange = () => {
    initalizeDiagrams()

    const requiredFields = document.querySelectorAll(".required")
    for (let field of requiredFields) {
        field.required = true
    }

    mountTooltips()
}

const contentPane = document.getElementById("content-pane")
if (contentPane !== null) {
    let observer = new MutationObserver(onDomChange)
    observer.observe(contentPane, {
        subtree: true,
        childList: true,
    })
}

/**
 * ------------------------------
 * Cookie Banner
 * ------------------------------
 */
const initCookieBanner = () => {
    const button = document.getElementById("cookie-accept-banner")

    if (button !== null) {
        button.addEventListener("click", () => {
            document.cookie = button.dataset.cookieString
            document.querySelector(".cookiebanner").remove()
        })
    }
}

/**
 * ------------------------------
 * Conditional Areas
 * ------------------------------
 */

/*
 * Helper um einfach ausblendbare Panels zu bauen, welche mit eine Checkbox bestimmt werden
 * Achtung:
 *  - gibt es für den Wert kein Template, bleibt das Target leer
 *  - das Target wird bei jeder Änderung (DOM Technisch) neu erzeugt.
 *
  HOWTO:
 
    Trigger (Value muss stimmen) =>
        <input
            type="radio"
            name="Muster"
            value="Value1" />
        
        oder

        <select name="Muster">
            <option value="Value1">Test</option>
        </select>
    
    Template (wird injected wenn data-value == checkboxValue) =>
        <template 
            data-conditional-provider="Muster" 
            data-value="Value1">
            ...
        </template>

    Target (bekommt das Template injiziert) =>
        <div data-conditional-area="Muster">
            ...
        </div>
 */

/**
 * Builds the conditional area
 * @param {HTMLDivElement} oDomTarget TargetElement
 */
function buildConditionalArea(oDomTarget) {
    const conditionalAreaName = oDomTarget.dataset.conditionalArea
    const targets = document.querySelectorAll(`[name="${conditionalAreaName}"]`)
    const providers = [
        ...document.querySelectorAll(
            `[data-conditional-provider="${conditionalAreaName}"]`
        ),
    ]

    const switchContent = (e) => {
        const target = e.currentTarget.value
        const targetTemplate = providers.find((o) => o.dataset.value === target)

        if (e.currentTarget.type === "radio" && !e.currentTarget.checked) return

        oDomTarget.innerHTML = ""

        if (targetTemplate !== undefined) {
            const clone = document.importNode(targetTemplate.content, true)
            oDomTarget.appendChild(clone)
            const event = new Event("conditionalAreaChange")
            document.dispatchEvent(event)
        }

        const changeEvt = new CustomEvent("changeContent", {
            currentTarget: oDomTarget,
            detail: {
                currentValue: target,
            },
        })
        oDomTarget.dispatchEvent(changeEvt)
    }

    oDomTarget.addEventListener("changeContent", (e) => {
        e.target
            .querySelectorAll("[data-conditional-area]")
            .forEach((e) => buildConditionalArea(e))
    })

    targets.forEach((r) => {
        r.addEventListener("change", switchContent)
        switchContent({
            currentTarget: r,
        })
    })
}

function attachConditinalAreas() {
    document
        .querySelectorAll("[data-conditional-area]")
        .forEach((e) => buildConditionalArea(e))
}

function mountTooltips() {
    const buildModal = (sText) => {
        const modalCode = `<div class="modal fade" tabindex="-1">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Info</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body tooltip-expanded-modal">
                <p>${sText}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Schließen</button>
              </div>
            </div>
          </div>
        </div>`

        const wrapper = document.createElement("div")
        wrapper.innerHTML = modalCode

        document.querySelector("body").appendChild(wrapper)

        const modal = wrapper.querySelector(".modal")
        const bsModal = new bootstrap.Modal(modal)

        modal.addEventListener("hidden.bs.modal", () => wrapper.remove())
        bsModal.show()
    }

    const onClick = (oEvent) => {
        const { currentTarget } = oEvent
        const dataset = currentTarget.dataset

        const text = dataset["bsOriginalTitle"] ?? dataset["bsTitle"]

        buildModal(text)
    }

    const tooltipTriggerList = [
        ...document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    ]
    for (let tooltipItem of tooltipTriggerList) {
        if (tooltipItem.dataset.mounted == undefined) {
            tooltipItem.dataset.mounted = 1
            new bootstrap.Tooltip(tooltipItem)
            tooltipItem.addEventListener("click", onClick)
        }
    }
}

/**
 * ------------------------------
 * On Ready
 * ------------------------------
 */

window.addEventListener("load", () => {
    onDomChange()
    //initCountdown()
    initCookieBanner()

    attachConditinalAreas()
})
